export default "__VITE_ASSET__Bgd_ZzZq__";